// extracted by mini-css-extract-plugin
module.exports = {"bg_general_popup":"GeneralPopup_bg_general_popup__RRA7e","text_shadow":"GeneralPopup_text_shadow__jDDPU"};